import { useRumTracking } from "../hooks/useRumTracking";

export function RumTracker() {
  useRumTracking();
  return null;
}
